import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailValid',
  standalone: false
})
export class EmailValidPipe implements PipeTransform {
  private emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  transform(value: string | null | undefined): string {
    if (!value) return 'Email vazio';

    return this.emailRegex.test(value) ? 'Email válido' : 'Email inválido';
  }
}
